import {
  Button,
  Card,
  CardBody,
  Collapse,
  Typography,
} from "@material-tailwind/react";
import React from "react";
import "./fonts.css";

export default function AboutTextArea() {
  const [open, setOpen] = React.useState(false);

  const toggleOpen = () => setOpen((cur) => !cur);
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 md:gap-36 gap-20 my-32 w-full relative">
      <div className="col-span-1 flex flex-col gap-9 justify-center mr-4">
        <h2 className=" text-2xl md:text-4xl flex items-end gap-2">
          <img
            src="/hat-color.png"
            alt="hat"
            className="w-[40px] md:w-[60px] h-[40px] md:h-[58px]"
          />
          <span>How site works</span>
        </h2>
        <div className="flex flex-col gap-6 md:gap-10">
          <p className="leading-8 md:leading-10">
            Anon Detect operates as your one-stop hub for a seamless blend of
            free and premium resources. Simply explore our intuitive interface,
            browse through diverse categories such as e-learning, e-books,
            software, mod APKs, and wallpapers.
          </p>
          <p className="leading-8 md:leading-10">
            Access an array of high-quality
          </p>
        </div>
        <div className="w-full md:pr-10">
          <Button
            onClick={toggleOpen}
            className="bg-transparent border border-black text-black w-full text-left flex items-center justify-between"
          >
            <div className="flex items-center gap-3">
              <img src="/about/dot.png" alt="dot" />
              <p className="hover:text-blue-500">Getting Started Guide</p>
            </div>
            <img src="/about/plus.png" alt="dot" />
          </Button>
          <Collapse open={open}>
            <Card className="my-4 mx-auto w-8/12">
              <CardBody>
                <Typography>
                  free content or elevate your experience with our premium
                  offerings for exclusive benefits. Whether you're here for
                  knowledge, entertainment, or both, Anon Detect simplifies your
                  quest for valuable resources. Explore, engage, and enjoy the
                  best of what our platform has to offer.
                </Typography>
              </CardBody>
            </Card>
          </Collapse>
        </div>
      </div>
      <div className="col-span-1 flex flex-col gap-9 justify-center mr-4">
        <h2 className=" text-2xl md:text-4xl flex items-end gap-2">
          <img
            src="/hat-color.png"
            alt="hat"
            className="w-[40px] md:w-[60px] h-[40px] md:h-[58px]"
          />
          <span>Terms & Condition</span>
        </h2>
        <div className="flex flex-col gap-6 md:gap-10">
          <p className="leading-8 md:leading-10">
            By accessing and using the Anon Detect website, users agree to
            comply with all applicable terms and conditions. Content provided on
            the site, including free and premium resources, is for personal use
            only, and unauthorized redistribution is strictly prohibited. 
          </p>
          <p className="leading-8 md:leading-10"></p>
        </div>
        <div className="flex items-center gap-4">
          <p className="text-blue-700">Check Our Privacy Policy</p>
        </div>
      </div>
      <div className="w-[1px] h-[249px] bg-gray-600 absolute left-[47%] top-[35%] transform -translate-x-1/2 hidden md:block"></div>
    </div>
  );
}
